import "./brokerCryptoToast.scss";

// @vendors
import PropTypes from "prop-types";
import { useEffect } from "react";

const BrokerCryptoToast = ({ message, show, onClose }) => {

    useEffect(() => {
        if (show && onClose) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div
            className={`crypto-toast ${
                show ? "crypto-toast-show" : "crypto-toast-hiden"
            }`}
        >
            <div className="crypto-toast-content">
                <div className="crypto-toast-content-left">
                    <div className="crypto-toast-icon-success" />
                    <span className="crypto-toast-message">{message}</span>
                </div>
                <div className="crypto-toast-content-right">
                    <i
                        className="crypto-toast-close"
                        onClick={handleClose}
                        aria-label="Close toast"
                        role="button"
                        tabIndex={0}
                    />
                </div>
            </div>
        </div>
    );
};

BrokerCryptoToast.propTypes = {
    message: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
};

export default BrokerCryptoToast;
